import { Helmet } from 'react-helmet-async';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Pricing Penguin',
  url: 'https://www.pricingpenguin.co.uk',
  description: 'AI-powered home improvement quoting platform connecting UK homeowners with trusted tradespeople.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://www.pricingpenguin.co.uk/chat?q={search_term_string}'
    },
    'query-input': 'required name=search_term_string'
  }
};

const WebSiteSchema = () => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  </Helmet>
);

export default WebSiteSchema;
